export const RATE_TYPE_OPTIONS = [
  { label: 'RPM', value: 'rfp_lane_carrier_line_haul_rpm' },
  { label: 'All-In', value: 'rfp_lane_carrier_all_in' },
  { label: 'Line Haul', value: 'rfp_lane_carrier_line_haul_flat' },
]
